import React from "react";

//components
import { Avatar, ColGroupDef, ICellRendererParams, Link, PYColumnDef, Text } from "@performyard/py-components";

// utils
import toEmployeeUrl from "../../../../../../utils/URLs/Employee";

import { Assignment } from "..";

const EmployeeCellRenderer = (params: ICellRendererParams<Assignment>) => {
	const assignment = params.data;
	if (!assignment) return null;

	const { _id, name } = assignment;

	if (!name) {
		return (
			<div className="flex h-full items-center">
				<Text size="paragraph-3" dangerouslySetClassName="py-line-clamp-1">
					Unassigned
				</Text>
			</div>
		);
	}

	return (
		<Link href={toEmployeeUrl(_id)} isExternal>
			<div className="flex h-full items-center gap-1">
				<Avatar size={20} id={_id} alt={`${name}'s avatar`} />
				<Text size="paragraph-3" dangerouslySetClassName="py-line-clamp-1">
					{name}
				</Text>
			</div>
		</Link>
	);
};

const getAssignmentsCols = (): PYColumnDef<Assignment>[] => {
	return [
		{
			field: "lower_name_sortable",
			headerName: "Employees",
			sortable: true,
			resizable: false,
			width: 230,
			cellRenderer: EmployeeCellRenderer,
		},
		{
			headerName: "Current Author",
			children: [
				{
					field: "current_author_assigned",
					headerName: "Assigned",
					sortable: true,
					resizable: false,
					width: 108,
				},
				{
					field: "current_author_overdue_assigned",
					headerName: "Overdue",
					sortable: true,
					resizable: false,
					width: 108,
				},
			],
		} as ColGroupDef<Assignment>,
		{
			headerName: "On Deck Author",
			children: [
				{
					field: "waiting_author_assigned",
					headerName: "Assigned",
					sortable: true,
					resizable: false,
					width: 108,
				},
				{
					field: "waiting_author_overdue",
					headerName: "Overdue",
					sortable: true,
					resizable: false,
					width: 108,
				},
			],
		} as ColGroupDef<Assignment>,
		{
			headerName: "Current Signer",
			children: [
				{
					field: "current_signer_assigned",
					headerName: "Assigned",
					sortable: true,
					resizable: false,
					width: 108,
				},
				{
					field: "current_signer_overdue_assigned",
					headerName: "Overdue",
					sortable: true,
					resizable: false,
					width: 108,
				},
			],
		} as ColGroupDef<Assignment>,
		{
			headerName: "On Deck Signer",
			children: [
				{
					field: "waiting_signer_assigned",
					headerName: "Assigned",
					sortable: true,
					resizable: false,
					width: 108,
				},
				{
					field: "waiting_signer_overdue",
					headerName: "Overdue",
					sortable: true,
					resizable: false,
					width: 108,
				},
			],
		} as ColGroupDef<Assignment>,
	];
};

export default getAssignmentsCols;
